import React from "react";
import { Image as RNImage } from "react-native";
import FastImage from "react-native-fast-image";

const ImageProviders = {
  fast_image: "fast_image",
  rn_image: "rn_image",
};

const ImageProvider = ImageProviders.fast_image;

const isFastImage = ImageProvider === ImageProviders.fast_image;

const ImageComponent = {
  [ImageProviders.fast_image]: () => FastImage,
  [ImageProviders.rn_image]: () => RNImage,
}[ImageProvider]();

const Image = ({ source, style, resizeMode, ...rest }) => {
  return (
    <ImageComponent
      source={source}
      style={style}
      fadeDuration={0}
      resizeMode={resizeMode ?? ImageComponent.resizeMode.contain}
      {...rest}
    />
  );
};

Image.priority = (() => {
  const priority = { normal: "normal", high: "high", low: "low" };
  if (ImageProvider === ImageProviders.fast_image) {
    priority.normal = ImageComponent.priority.normal;
    priority.high = ImageComponent.priority.high;
    priority.low = ImageComponent.priority.normal;
  }
  return priority;
})();

Image.memory = (() => {
  const memory = {
    preload: () => {},
    clearMemoryCache: () => {},
    clearDiskCache: () => {},
  };

  if (ImageProvider === ImageProviders.fast_image) {
    memory.preload = ImageComponent.preload;
    memory.clearMemoryCache = ImageComponent.clearMemoryCache;
    memory.clearDiskCache = ImageComponent.clearDiskCache;
  }
  return memory;
})();

Image.resizeMode = (() => {
  const resizeMode = {
    contain: "contain",
    cover: "cover",
    stretch: "stretch",
    center: "center",
    ...(ImageProvider === ImageProviders.fast_image
      ? {
          ...ImageComponent.resizeMode,
          contain: ImageComponent?.resizeMode?.contain ?? "contain",
          cover: ImageComponent?.resizeMode?.cover ?? "cover",
          stretch: ImageComponent?.resizeMode?.stretch ?? "stretch",
          center: ImageComponent?.resizeMode?.center ?? "center",
        }
      : {}),
  };
  return resizeMode;
})();

export { Image as default, isFastImage };
